export default __webpack_public_path__ + "static/media/zais-logo.b7be3f5a.png";